import { useEffect, useState } from 'react';
import '../css/App.css';
import StorefrontLayout from './StorefrontLayout';
import { StudioImage } from '../studio/UI';

const eventImages = [
    { src: '/studio/events/athenaeum-poster.webp', alt: 'Athenaeum Art Center 10th anniversary event poster', label: 'Event poster' },
    { src: '/studio/events/athenaeum-photo-1.webp', alt: 'Two exhibitors behind a table of Delaney Stewart prints at the Athenaeum event', label: 'At the event' },
    { src: '/studio/events/athenaeum-photo-2.webp', alt: 'Framed prints and small editions on the event display table', label: 'Print display' },
    { src: '/studio/events/athenaeum-photo-3.webp', alt: 'A side view of the print display with a hanging owl textile', label: 'Table details' },
];

// The event ends at 4 pm in San Diego (Pacific daylight time).
const eventEndsAt = Date.parse('2026-09-26T16:00:00-07:00');

const Events = ({ images = eventImages }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const activeImage = images[activeIndex] || images[0];
    const [open, setOpen] = useState(false);
    const [now, setNow] = useState(Date.now);
    const isPast = now >= eventEndsAt;

    useEffect(() => {
        const updateTime = () => setNow(Date.now());
        const timer = window.setInterval(updateTime, 60000);
        window.addEventListener('focus', updateTime);
        return () => {
            window.clearInterval(timer);
            window.removeEventListener('focus', updateTime);
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const onKey = (event) => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open]);

    return (
        <StorefrontLayout>
            <main className="eventsPage">
                <div className="eventsLayout">
                    {activeImage && <div className="eventsGallery">
                        <button type="button" className="eventsPosterButton" onClick={() => setOpen(true)} aria-label={`Enlarge ${activeImage.label}`}>
                            <StudioImage className="eventsPoster" src={activeImage.src} alt={activeImage.alt} sizes="(max-width: 760px) 100vw, 420px" />
                        </button>
                        {images.length > 1 && <div className="eventsThumbnails" role="group" aria-label="Event images">
                            {images.map((image, index) => <button key={image.src} type="button" className="eventsThumbnail" aria-label={`Show ${image.label}`} aria-pressed={index === activeIndex} onClick={() => setActiveIndex(index)}>
                                <StudioImage src={image.src} alt="" sizes="160px" />
                            </button>)}
                        </div>}
                    </div>}
                    <div className="eventsText">
                        <p className="eventsKicker">{isPast ? 'Past event' : 'Upcoming event'}</p>
                        <h1 className="eventsTitle">Athenaeum Art Center</h1>
                        <p className="eventsMeta">10th Anniversary · September 26, 2026 · 11am–4pm PT</p>
                        <div className="eventsCopy">
                            <p>
                                {isPast ? 'Delaney was at' : 'Delaney will be at'} the Athenaeum Art Center’s tenth anniversary on Saturday, September 26, with a table of hand-pulled prints — including small-edition work from the studio.
                            </p>
                            <p>
                                {isPast
                                    ? 'The event took place at 1955 Julian Ave, San Diego, from 11am to 4pm.'
                                    : 'Stop by 1955 Julian Ave, San Diego, from 11am to 4pm to look through the work, talk process, and take a print home.'}
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            {open && activeImage ?
                <button
                    type="button"
                    className="eventsLightbox"
                    onClick={() => setOpen(false)}
                    aria-label="Close event image"
                >
                    <StudioImage src={activeImage.src} alt={activeImage.alt} sizes="90vw" />
                </button>
                : null}
        </StorefrontLayout>
    );
};

export default Events;
